import { Layout as ALayout } from "antd"
import { MainMenu } from "../main-menu"
import { Toolbar } from "../toolbar"
import PropTypes from "prop-types"
import { MainMenuStyledContainer } from "../main-menu/main-menu-styled-components";

Layout.propTypes = {
  children: PropTypes.node,
  subheader: PropTypes.node
}

export function Layout({ children, subheader }) {
  return (
    <div className="fico layout">
      <ALayout>
        <ALayout.Sider>
          <MainMenuStyledContainer>
            <MainMenu />
          </MainMenuStyledContainer>
        </ALayout.Sider>
        <ALayout className="content">
          <ALayout.Header><Toolbar subheader={subheader} /></ALayout.Header>
          <ALayout.Content>
            <div className="full-height page-content">
              {children}
            </div>
          </ALayout.Content>
        </ALayout>
      </ALayout>
    </div>
  )
}
